








import { Component, Vue } from 'vue-property-decorator';
import { RegisterModule } from './store/modules/register';
@Component({
  name: 'App',
})
export default class extends Vue {
  // Register: 缓存手机号、验证码、勾选协议
  // Welcome: 缓存二维码弹窗，防止多次弹出
  private keepAliveViews = ['Register', 'Welcome'];

  created() {
    console.log(window.location.href);
    RegisterModule.SET_FIRST_URL(location.href.split('#')[0]);
  }

  mounted() {
    // 安卓键盘不收起 bug
    this.andriodInputBug();
  }

  // 解决安卓点击input，弹出键盘挡住input的问题
  private andriodInputBug() {
    if (/android/gi.test(navigator.userAgent)) {
      window.addEventListener('resize', function() {
        if (
          document.activeElement?.tagName == 'INPUT' ||
          document.activeElement?.tagName == 'TEXTAREA'
        ) {
          window.setTimeout(function() {
            (document.activeElement as any)?.scrollIntoViewIfNeeded();
          }, 0);
        }
      });
    }
  }
}
